/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GroupDto } from './GroupDto';
import {
    GroupDtoFromJSON,
    GroupDtoFromJSONTyped,
    GroupDtoToJSON,
    GroupDtoToJSONTyped,
} from './GroupDto';
import type { PartDto } from './PartDto';
import {
    PartDtoFromJSON,
    PartDtoFromJSONTyped,
    PartDtoToJSON,
    PartDtoToJSONTyped,
} from './PartDto';
import type { ParameterDto } from './ParameterDto';
import {
    ParameterDtoFromJSON,
    ParameterDtoFromJSONTyped,
    ParameterDtoToJSON,
    ParameterDtoToJSONTyped,
} from './ParameterDto';

/**
 * 
 * @export
 * @interface ControlExtendedDto
 */
export interface ControlExtendedDto {
    /**
     * 
     * @type {string}
     * @memberof ControlExtendedDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlExtendedDto
     */
    controlId?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlExtendedDto
     */
    controlClass?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlExtendedDto
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlExtendedDto
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlExtendedDto
     */
    controlStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlExtendedDto
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlExtendedDto
     */
    catalogName?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlExtendedDto
     */
    groupName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlExtendedDto
     */
    hasParameters?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlExtendedDto
     */
    hasParts?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlExtendedDto
     */
    hasSubControls?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlExtendedDto
     */
    parentControlId?: string;
    /**
     * 
     * @type {Date}
     * @memberof ControlExtendedDto
     */
    created?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ControlExtendedDto
     */
    updated?: Date;
    /**
     * 
     * @type {Array<ControlExtendedDto>}
     * @memberof ControlExtendedDto
     */
    subControls?: Array<ControlExtendedDto>;
    /**
     * 
     * @type {Array<ParameterDto>}
     * @memberof ControlExtendedDto
     */
    parameters?: Array<ParameterDto>;
    /**
     * 
     * @type {Array<PartDto>}
     * @memberof ControlExtendedDto
     */
    parts?: Array<PartDto>;
    /**
     * 
     * @type {GroupDto}
     * @memberof ControlExtendedDto
     */
    group?: GroupDto;
}

/**
 * Check if a given object implements the ControlExtendedDto interface.
 */
export function instanceOfControlExtendedDto(value: object): value is ControlExtendedDto {
    return true;
}

export function ControlExtendedDtoFromJSON(json: any): ControlExtendedDto {
    return ControlExtendedDtoFromJSONTyped(json, false);
}

export function ControlExtendedDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlExtendedDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'controlId': json['controlId'] == null ? undefined : json['controlId'],
        'controlClass': json['controlClass'] == null ? undefined : json['controlClass'],
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'controlStatus': json['controlStatus'] == null ? undefined : json['controlStatus'],
        'status': json['status'] == null ? undefined : json['status'],
        'catalogName': json['catalogName'] == null ? undefined : json['catalogName'],
        'groupName': json['groupName'] == null ? undefined : json['groupName'],
        'hasParameters': json['hasParameters'] == null ? undefined : json['hasParameters'],
        'hasParts': json['hasParts'] == null ? undefined : json['hasParts'],
        'hasSubControls': json['hasSubControls'] == null ? undefined : json['hasSubControls'],
        'parentControlId': json['parentControlId'] == null ? undefined : json['parentControlId'],
        'created': json['created'] == null ? undefined : (new Date(json['created'])),
        'updated': json['updated'] == null ? undefined : (new Date(json['updated'])),
        'subControls': json['subControls'] == null ? undefined : ((json['subControls'] as Array<any>).map(ControlExtendedDtoFromJSON)),
        'parameters': json['parameters'] == null ? undefined : ((json['parameters'] as Array<any>).map(ParameterDtoFromJSON)),
        'parts': json['parts'] == null ? undefined : ((json['parts'] as Array<any>).map(PartDtoFromJSON)),
        'group': json['group'] == null ? undefined : GroupDtoFromJSON(json['group']),
    };
}

export function ControlExtendedDtoToJSON(json: any): ControlExtendedDto {
    return ControlExtendedDtoToJSONTyped(json, false);
}

export function ControlExtendedDtoToJSONTyped(value?: ControlExtendedDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'controlId': value['controlId'],
        'controlClass': value['controlClass'],
        'title': value['title'],
        'description': value['description'],
        'controlStatus': value['controlStatus'],
        'status': value['status'],
        'catalogName': value['catalogName'],
        'groupName': value['groupName'],
        'hasParameters': value['hasParameters'],
        'hasParts': value['hasParts'],
        'hasSubControls': value['hasSubControls'],
        'parentControlId': value['parentControlId'],
        'created': value['created'] == null ? undefined : ((value['created']).toISOString()),
        'updated': value['updated'] == null ? undefined : ((value['updated']).toISOString()),
        'subControls': value['subControls'] == null ? undefined : ((value['subControls'] as Array<any>).map(ControlExtendedDtoToJSON)),
        'parameters': value['parameters'] == null ? undefined : ((value['parameters'] as Array<any>).map(ParameterDtoToJSON)),
        'parts': value['parts'] == null ? undefined : ((value['parts'] as Array<any>).map(PartDtoToJSON)),
        'group': GroupDtoToJSON(value['group']),
    };
}

